import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TAttachmentType {
  id: number;
  name: string;
  attachmentContentTypeId: number;
  organisationId: number;
  anonymisationRequired: boolean;
  valid: boolean;
}

export interface IAttachmentType extends TAttachmentType {}

const AttachmentType = Model((model: TAttachmentType): IAttachmentType => {
  const _value: TAttachmentType = Object.assign({}, model);

  let _model = {
    get id() {
      return _value.id;
    },
    set id(value) {
      _value.id = value;
    },
    get name() {
      return _value.name;
    },
    set name(value) {
      _value.name = value;
    },
    get valid() {
      return _value.valid;
    },
    set valid(value) {
      _value.valid = value;
    },
    get attachmentContentTypeId() {
      return _value.attachmentContentTypeId;
    },
    set attachmentContentTypeId(value) {
      _value.attachmentContentTypeId = value;
    },
    get anonymisationRequired() {
      return _value.anonymisationRequired;
    },
    set anonymisationRequired(value) {
      _value.anonymisationRequired = value;
    },
    get organisationId() {
      return _value.organisationId;
    },
    set organisationId(value) {
      _value.organisationId = value;
    }
  };

  return ValidatableObject<IAttachmentType>(_model);
});

export default AttachmentType;
